import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { EventType, PublicClientApplication } from '@azure/msal-browser';

import './index.css';
import { store } from './app/store';
import { azureConfig } from './config/azure.config';
import { buildRouter } from './routes/AppRoutes';

const msalInstance = new PublicClientApplication(azureConfig);

msalInstance.initialize().then(async () => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  const router = buildRouter(msalInstance);
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
});
